import {useSelector} from "react-redux";

import {abTestingSelector} from "@pg-mono/ab-testing";
import {safelyParsePage} from "@pg-mono/string-utils";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../ab_testing/dsa_rating_sort_ab_test";
import {IRPStore} from "../../app/rp_reducer";
import {useCurrentRoute} from "../../hooks/use_current_route";
import {OfferModal} from "../../offer/components/offer_modal/OfferModal";
import {getOfferListSortName} from "../../offer/helpers/get_offer_list_sort_name";
import {useInvestmentOffers} from "../../offer/hooks/use_investment_offers";
import {SearchSortString} from "../../offer/list/constants/SearchSort";
import {IOfferModalName} from "../../offer/types/OfferModalName";
import {useAppSelector} from "../../store/hooks";
import {INVESTMENT_OFFER_LIST_PAGE_SIZE} from "../list/actions/fetch_investment_offer_list";

const modalName: IOfferModalName = "mainOfferModal";

export function InvestmentOfferListModal() {
    const {query} = useCurrentRoute();

    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);

    const listingQueryParams = useSelector((state: IRPStore) => state.investmentOffer.list.offers.latestQuery);
    const useDsaSort = isDsaRatingSortTreatmentVariant(useAppSelector(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)));

    const investmentOffersQuery = useInvestmentOffers(!isOpen, {
        ...listingQueryParams,
        page,
        page_size: pageSize,
        sort: getOfferListSortName(query.sort as SearchSortString, useDsaSort)
    });

    return (
        <OfferModal
            modalName={modalName}
            offersQuery={investmentOffersQuery}
            initialQueryParams={{
                listingPage: safelyParsePage(query.page as string),
                listingPageSize: INVESTMENT_OFFER_LIST_PAGE_SIZE
            }}
        />
    );
}
import {useSelector} from "react-redux";

import {abTestingSelector} from "@pg-mono/ab-testing";
import {safelyParsePage} from "@pg-mono/string-utils";

import {DSA_RATING_SORT_AB_TEST_ID, isDsaRatingSortTreatmentVariant} from "../../ab_testing/dsa_rating_sort_ab_test";
import {IRPStore} from "../../app/rp_reducer";
import {useCurrentRoute} from "../../hooks/use_current_route";
import {OfferModal} from "../../offer/components/offer_modal/OfferModal";
import {getOfferListSortName} from "../../offer/helpers/get_offer_list_sort_name";
import {useInvestmentOffers} from "../../offer/hooks/use_investment_offers";
import {SearchSortString} from "../../offer/list/constants/SearchSort";
import {IOfferModalName} from "../../offer/types/OfferModalName";
import {useAppSelector} from "../../store/hooks";
import {INVESTMENT_OFFER_LIST_PAGE_SIZE} from "../list/actions/fetch_investment_offer_list";

const modalName: IOfferModalName = "mainOfferModal";

export function InvestmentOfferListModal() {
    const {query} = useCurrentRoute();

    const isOpen = useAppSelector((state) => state.offerModals[modalName].isOpen);
    const page = useAppSelector((state) => state.offerModals[modalName].listingPage);
    const pageSize = useAppSelector((state) => state.offerModals[modalName].listingPageSize);

    const listingQueryParams = useSelector((state: IRPStore) => state.investmentOffer.list.offers.latestQuery);
    const useDsaSort = isDsaRatingSortTreatmentVariant(useAppSelector(abTestingSelector(DSA_RATING_SORT_AB_TEST_ID)));

    const investmentOffersQuery = useInvestmentOffers(!isOpen, {
        ...listingQueryParams,
        page,
        page_size: pageSize,
        sort: getOfferListSortName(query.sort as SearchSortString, useDsaSort)
    });

    return (
        <OfferModal
            modalName={modalName}
            offersQuery={investmentOffersQuery}
            initialQueryParams={{
                listingPage: safelyParsePage(query.page as string),
                listingPageSize: INVESTMENT_OFFER_LIST_PAGE_SIZE
            }}
        />
    );
}
